import { keyframes } from '@mui/system';

export const pageTransitionDurationMs = 500;

export const transitionStylesCrossFadeOut = {
  entering: {
    opacity: '100%',
    transform: 'scale(100%)',
    visibility: 'visible',
  },
  entered:  {
    opacity: '100%',
    transform: 'scale(100%)',
    visibility: 'visible',
  },
  exiting:  {
    opacity: '0%',
    transform: 'scale(200%)',
    visibility: 'hidden',
  },
  exited:  {
    opacity: '0%',
    transform: 'scale(200%)',
    visibility: 'hidden',
  },
};

export const transitionStylesCrossFadeIn = {
  entering: {
    opacity: '100%',
    transform: 'scale(100%)',
    visibility: 'visible',
  },
  entered:  {
    opacity: '100%',
    transform: 'scale(100%)',
    visibility: 'visible',
  },
  exiting:  {
    opacity: '0%',
    transform: 'scale(50%)',
    visibility: 'hidden',
  },
  exited:  {
    opacity: '0%',
    transform: 'scale(50%)',
    visibility: 'hidden',
  },
};

export const transitionStylesFadeIn = {
  entering: {
    opacity: '100%',
    visibility: 'visible',
  },
  entered:  {
    opacity: '100%',
    visibility: 'visible',
  },
  exiting:  {
    opacity: '0%',
    visibility: 'hidden',
  },
  exited:  {
    opacity: '0%',
    visibility: 'hidden',
  },
};

export const transitionStylesMetaFade = {
  entering: {
    opacity: '1',
    transform: 'translateY(0%)',
  },
  entered:  {
    opacity: '1',
    transform: 'translateY(0%)',
  },
  exiting:  {
    opacity: '0',
    transform: 'translateY(150%)',
  },
  exited:  {
    opacity: '0',
    transform: 'translateY(150%)',
  },
};

export const FadeInAnimation = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const FadeOutAnimation = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;
